import httpClient from '@/lib/httpClient.js'
import { useMutation, useQueryClient } from '@tanstack/react-query'
import { toast } from 'sonner'

export default function useCreateCustomTransactionRepeat() {
  const queryClient = useQueryClient()

  const action = async (payload) => {
    const response = await httpClient.post(
      '/team/cash-flow/transactions/recurring-settings',
      payload,
    )
    return response
  }

  const mutation = useMutation({
    mutationFn: action,
    onError: (e) => {
      toast.error(e?.response?.data?.message ?? 'An error occurred.')
    },
    onSuccess: (response, payload) => {
      const optionsArray = Object.entries(response.data.data.options).map(
        ([name, props]) => ({
          name,
          ...props,
        }),
      )

      queryClient.setQueryData(
        [
          'transaction-repeat-options',
          {
            date: payload.transaction_date,
            recurring_setting_id: payload.rid,
          },
        ],
        optionsArray,
      )
    },
  })

  return {
    action: mutation.mutateAsync,
    status: mutation,
  }
}
